module.exports = __webpack_public_path__ + "static/media/dart.ebcbef5c.png";